export default __webpack_public_path__ + "static/media/Roshdy.5bfacedd.png";